export default [
  {
    path: '/inWarehouse/bySelect',
    name: 'inWarehouse/bySelect',
    meta:{
      title:"入库扫码"
    },
    component: () => import('@/views/inWarehouse/bySelect')
  },
  {
    path: '/inWarehouse/byOrder',
    name: 'inWarehouse/byOrder',
    meta:{
      title:"按单入库"
    },
    component: () => import('@/views/inWarehouse/byOrder')
  },
  {
    path: '/inWarehouse/byFast',
    name: 'inWarehouse/byFast',
    meta:{
      title:"快速入库"
    },
    component: () => import('@/views/inWarehouse/byFast')
  },
  {
    path: '/inWarehouse/order',
    name: 'inWarehouse/order',
    meta:{
      title:"入库单"
    },
    component: () => import('@/views/inWarehouse/order')
  },
  {
    path: '/inWarehouse/orderDetail',
    name: 'inWarehouse/orderDetail',
    meta:{
      title:"入库单详情"
    },
    component: () => import('@/views/inWarehouse/orderDetail')
  }
]
